import { Plus, Trash2 } from "lucide-react";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { InputField } from "@/components/common";

const QuestionOptionsEditor = ({
  options,
  questionType,
  isEditable,
  onAddOption,
  onOptionLabelChange,
  onRemoveOption,
}) => {
  const { t } = useTran();
  const isCustomDropdown = questionType === "custom_dropdown";

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {t("Options")}
          </p>
          <p className="text-[11px] text-muted-foreground">
            {t("Define answer choices and scoring.")}
          </p>
        </div>
        {isEditable ? (
          <Button
            type="button"
            size="sm"
            onClick={onAddOption}
            variant="secondary"
            className="rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Plus className="mr-1 h-4 w-4" />
            {t("Add Option")}
          </Button>
        ) : null}
      </div>

      {isEditable ? (
        <div className="space-y-2">
          {(options || []).map((option, index) => (
            <div
              key={option.id ?? index}
              className={`grid items-end gap-3 rounded-radius border border-border bg-muted/40 p-3 ${
                isCustomDropdown ? "grid-cols-9" : "grid-cols-5" // ✅ wider grid for description
              }`}
            >
              <InputField
                label={t("Option")}
                labelClassName="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"
                value={option.label}
                onChange={(event) =>
                  onOptionLabelChange(index, event.target.value)
                }
                className={`space-y-1 ${isCustomDropdown ? "col-span-4" : "col-span-4"}`} // ✅
              />

              {isCustomDropdown ? (
                <InputField
                  label={t("Description")}
                  labelClassName="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"
                  value={option.description ?? ""}
                  onChange={(event) =>
                    onOptionLabelChange(index, {
                      description: event.target.value,
                    })
                  }
                  className="space-y-1 col-span-4" // ✅
                />
              ) : null}

              {/* ✅ Delete button always stays in last col, same row */}
              <div className="col-span-1 flex justify-end">
                <Button
                  type="button"
                  size="icon"
                  variant="destructive"
                  onClick={() => onRemoveOption(index)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">
          {t("Options are fixed for this question type.")}
        </p>
      )}
    </div>
  );
};

export default QuestionOptionsEditor;
